<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->
<template>
	<div class="rest-api md-grey-page website-edit">
		<div class="page-banner"></div>
		<section class="rest-api__section container-white">
			<div class="edit-page margin-top-60 text-center" v-if="!loaded">
				<p class="loading-text">Loading rest API settings<span>.</span><span>.</span><span>.</span></p>
			</div>
			<div class="" v-if="loaded">
				<h2 class="text-center">REST API Settings</h2>
				<div class="">
					<div class="edit-page__content">
						<a @click.prevent="$router.push('/settings/rest-api/add')" href="#" class="mdc-button mdc-button--raised">Add Supplier Rest API Access</a>
						<h3 class="margin-top-30 text-center" v-show="keys[0]">Suppliers</h3>
						<APIKey v-for="(apikey, index) in keys" :apikey="apikey" :key="index" @revoke="revoke(apikey)"></APIKey>
					</div>
				</div>

			</div>
		</section>
	</div>
</template>

<!-- ################################# -->
<!-- SCRIPT -->
<!-- ################################# -->
<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import APIKey  from '../components/APIKey.vue';

export default {
	data: function() {
		return {
			loaded: false,
			keys: []
		}
	},
	mixins: [utils],
	computed: {
	},
	components: {
		APIKey
	},
	mounted: async function(){
		this.keys = await api({endpoint: this.config.services.rest, path: '/keys', method: 'GET'});
		this.loaded = true;
	},
	methods: {
		revoke: async function(apikey) {
			await api({endpoint: this.config.services.rest, path: `/keys/${apikey.apikey}`, method: 'DELETE'});
			this.keys = await api({endpoint: this.config.services.rest, path: '/keys', method: 'GET'});
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/Settings-RestAPI.vue